"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-unknown-property */
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var _util_1 = require("../../_util");
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var animations_1 = __importDefault(require("../../animations"));
var icon_1 = __importDefault(require("../../icon"));
var BannerBtnItem_1 = __importDefault(require("./BannerBtnItem"));
var TabPc_1 = __importDefault(require("./TabPc"));
function Banner(props) {
    var _a = props.buttonList, buttonList = _a === void 0 ? [] : _a, title = props.title, content = props.content, backgroundUrl = props.backgroundUrl, backgroundVideoUrl = props.backgroundVideoUrl, backgroundUrlLogo = props.backgroundUrlLogo, _b = props.lightTheme, lightTheme = _b === void 0 ? true : _b, _c = props.liveType, liveType = _c === void 0 ? '' : _c, _d = props.tabList, tabList = _d === void 0 ? [] : _d, tagText = props.tagText, tagHref = props.tagHref, className = props.className, onCallback = props.onCallback;
    var _e = (0, react_1.useState)(false), status = _e[0], setStatus = _e[1];
    var _f = (0, react_1.useState)(false), expande = _f[0], setExpande = _f[1];
    var _g = (0, react_1.useState)(false), hover = _g[0], setHover = _g[1];
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var contentRef = (0, react_1.useRef)(null);
    // 这里是针对传递的数据为一个对象字符串，带有｛url，alt｝属性
    var formatBackgroundUrl = (0, _util_1.fomateFileData)(backgroundUrl).url;
    var _h = (0, _util_1.fomateFileData)(backgroundVideoUrl), formatBackgroundVideoUrl = _h.url, _j = _h.alt, alt = _j === void 0 ? '' : _j;
    var _k = (0, _util_1.fomateFileData)(backgroundUrlLogo), formatBackgroundUrlLogo = _k.url, _l = _k.alt, logoAlt = _l === void 0 ? '' : _l;
    var hasTabClass = tabList.length > 0 ? 'has-tab-list' : '';
    var hasVideo = !!formatBackgroundVideoUrl;
    // 背景视频渲染
    function renderBgVedio() {
        if (!formatBackgroundVideoUrl) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "container-video-bg" },
            react_1.default.createElement("video", { loop: true, muted: true, autoPlay: true, src: formatBackgroundVideoUrl, className: 'video-control', title: alt })));
    }
    // 背景图片渲染
    function renderBgImg() {
        var bgStyle = formatBackgroundUrl
            ? {
                background: "url(".concat(formatBackgroundUrl, ") center no-repeat "),
                backgroundSize: 'cover',
            }
            : {};
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('container-img-bg', {
                show: !hasVideo,
            }), style: bgStyle }));
    }
    // 广告标签
    function renderAdLabel() {
        if (!tagText) {
            return null;
        }
        return (react_1.default.createElement("a", { className: "banner-advertising", href: tagHref, target: "_blank", rel: "noreferrer", "report-event": "click_new_banner_ad", "report-ext1": tagHref },
            react_1.default.createElement("span", { className: "advertising-title" }, tagText),
            react_1.default.createElement(icon_1.default, { name: "arrow-enter", size: 24, color: "#600017", className: "ad-icon" })));
    }
    // title行（包含tab列表）
    function renderTitleContainer() {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('title-tab', hasTabClass) },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('title', {
                    'light-theme': lightTheme,
                    'title-audiovb': liveType === 'audiovb',
                }), dangerouslySetInnerHTML: { __html: title || '' } }),
            renderTab()));
    }
    function renderTabMobileMask() {
        if (!status) {
            return null;
        }
        return (react_1.default.createElement("section", { className: "tab-mobile-root" },
            react_1.default.createElement("div", { className: "tab-mobile-mask" }),
            react_1.default.createElement("div", { className: "tab-mobile-wrap", onClick: function () {
                    if (status) {
                        setStatus(false);
                    }
                } },
                react_1.default.createElement("ul", null,
                    tabList.map(renderTabItem),
                    react_1.default.createElement("li", { className: "close", onClick: function () {
                            if (status) {
                                setStatus(false);
                            }
                        } }, "\u53D6\u6D88")))));
    }
    function renderTabItem(item, index) {
        var _a = item || {}, text = _a.text, href = _a.href, chosed = _a.chosed;
        return (react_1.default.createElement("li", { key: index },
            react_1.default.createElement("a", { href: href, className: (0, classnames_1.default)({
                    on: chosed,
                }) }, text)));
    }
    // tab列表
    function renderTab() {
        if (tabList.length === 0) {
            return null;
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(TabPc_1.default, __assign({}, props)),
            react_1.default.createElement("div", { className: "tab-mobile" },
                react_1.default.createElement("div", { className: (0, classnames_1.default)('tab-text', {
                        'light-theme': lightTheme,
                    }), onClick: function () {
                        setStatus(true);
                    } },
                    react_1.default.createElement(icon_1.default, { name: "arrow-down", size: 24, color: status ? '#006eff' : '#000000', className: "active-icon" })))));
    }
    function renderBtnList() {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('btn-container', hasTabClass) }, buttonList.map(renderBtnItem)));
    }
    function renderBtnItem(item, index) {
        return (react_1.default.createElement(BannerBtnItem_1.default, __assign({ key: "btn-".concat(index) }, item, { liveType: liveType, onCallback: onCallback })));
    }
    // 渲染banner左侧区域
    function renderLeft() {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('container-left', {
                'left-max-width': tabList.length > 0,
            }) },
            renderAdLabel(),
            renderTitleContainer(),
            react_1.default.createElement("div", { className: "content-swap", onMouseOver: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } },
                react_1.default.createElement("div", { ref: contentRef, className: (0, classnames_1.default)('content', hasTabClass, {
                        'light-theme': lightTheme,
                        'audiovb-theme': liveType === 'audiovb',
                        'activity-theme': liveType === 'student',
                        expande: expande,
                    }), dangerouslySetInnerHTML: { __html: content || '' } }),
                renderContentHover()),
            renderBtnList()));
    }
    // 描述超过长度特殊hover模块
    function renderContentHover() {
        if (!expande || !hover) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "content-hover-swap" },
            react_1.default.createElement("div", { className: "content-hover", dangerouslySetInnerHTML: { __html: content || '' } })));
    }
    // 渲染banner右侧核心图区域
    function renderRight() {
        // 判断传的主题是否支持动效
        if (_util_1.LIVE_TYPE.includes(liveType)) {
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)('core-icon', hasTabClass, {
                    show: liveType,
                    'core-icon-sme': liveType === 'sme',
                    'core-icon-audiovb': liveType === 'audiovb',
                }) },
                react_1.default.createElement(animations_1.default, { liveType: liveType })));
        }
        if (!formatBackgroundUrlLogo) {
            return null;
        }
        return (react_1.default.createElement("img", { className: (0, classnames_1.default)('core-icon', hasTabClass, {
                show: !hasVideo,
            }), src: formatBackgroundUrlLogo, alt: logoAlt }));
    }
    function renderChild() {
        return (react_1.default.createElement("div", { className: 'container-external' },
            react_1.default.createElement("div", { className: 'container-children' },
                react_1.default.createElement("div", { className: (0, classnames_1.default)('child', {
                        'audiovb-child': liveType === 'audiovb',
                    }) },
                    renderLeft(),
                    renderRight(),
                    renderTabMobileMask()))));
    }
    (0, react_1.useEffect)(function () {
        if (contentRef.current) {
            var lineHeight = 28;
            if (contentRef.current.offsetHeight > lineHeight * 4) {
                setExpande(true);
            }
        }
    }, [expande]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(classPrefix, "-banner"), className) },
        react_1.default.createElement("div", { className: 'container' },
            renderBgVedio(),
            renderBgImg(),
            renderChild())));
}
exports.default = Banner;
//# sourceMappingURL=Banner.js.map